module.exports = __webpack_public_path__ + "img/KK.a033ebe0.png";